import React, { useState } from 'react';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { LibraryLayout } from './LibraryLayout';
import { SearchTextField } from 'src/components/BeaconV2Components/TableSearch';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import { LibraryTable } from './LibraryTable';
import { useLibrary } from './hooks/useLibrary';
import { getQueryParamValue } from 'src/utils/app';

export const LibrarySummary = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [pageNumber, setPageNumber] = useState(1);
  const pageSize = 20;

  const retailerId = parseInt(getQueryParamValue('rid') || '1');

  const { data: enhancedData, isLoading, isLoadingUserMetadata, error, refetch } = useLibrary({
    retailerId,
    searchTerm: searchQuery || undefined,
    pageNumber,
    pageSize,
    setPageNumber
  });


  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value);
    setPageNumber(1);
  };

  const handleExportClick = () => {
    // TODO: Implement export functionality
    console.log('Export clicked');
  };

  return (
    <BasePageContainer>
      <LibraryLayout>
        <Flex flexDirection="column">
          {/* Search and Export Section */}
          <Flex justifyContent="space-between" alignItems="center" marginBottom="32px">
            <SearchTextField placeholder="Search products" value={searchQuery} onChange={handleSearchChange} />
          </Flex>

          {/* Library Table */}
          <LibraryTable 
            data={enhancedData}
            isLoading={isLoading}
            isLoadingUserMetadata={isLoadingUserMetadata}
            error={error}
            searchQuery={searchQuery}
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            refetch={refetch}
          />
        </Flex>
      </LibraryLayout>
    </BasePageContainer>
  );
};
